import { render, staticRenderFns } from "./BookCard.vue?vue&type=template&id=a2d16932&scoped=true&"
import script from "./BookCard.vue?vue&type=script&lang=js&"
export * from "./BookCard.vue?vue&type=script&lang=js&"
import style0 from "./BookCard.vue?vue&type=style&index=0&id=a2d16932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d16932",
  null
  
)

export default component.exports